import { useTranslate } from '@va/localization';
import { ConfirmationDialogProps, ConfirmationModal } from '@va/shared/util-confirmation';

const PremiumCommisionConfirmationModal: React.FC<ConfirmationDialogProps & { value: boolean }> = ({
  onClose,
  onConfirm,
  value,
}) => {
  const translate = useTranslate();

  return (
    <ConfirmationModal
      info={translate(value ? 'modal.enablePremiumCommission.info' : 'modal.disablePremiumCommission.info')}
      title={translate(value ? 'modal.enablePremiumCommission.title' : 'modal.disablePremiumCommission.title')}
      onClose={onClose}
      onConfirmation={onConfirm}
      isOpen={true}
      actionButtonText={translate('button.confirm')}
    />
  );
};

export default PremiumCommisionConfirmationModal;
